const hook = {
    missing_events: 'Você precisa fornecer pelo menos um evento.',
    send_test_payload_failed: 'Falha ao enviar carga de teste: {{message}}',
    endpoint_responded_with_error: 'O ponto de extremidade respondeu com erro.',
};
export default Object.freeze(hook);
